import { useTranslation } from "react-i18next";
import { Box, Grid, Typography } from "@material-ui/core";
import ProcessedEmailsCard from "./ProcessedEmailsCard";
import StorageUploadsCard from "./StorageUploadsCard";
import EmailFlowCard from "./EmailFlowCard";
import AccountsBlock from "./Accounts";
import { filterLastMonth, filterPreviousToLast } from "./utils";

import { StatRecord } from "@dashboard-v3/api";

interface Props {
  stats: StatRecord[];
  loading: boolean;
}

export default function StatCards(props: Props) {
  const { stats, loading } = props;
  const { t } = useTranslation("usageReports");
  const previousStats = stats.filter(filterPreviousToLast);
  const currentStats = stats.filter(filterLastMonth);

  return (
    <>
      <Box marginBottom="15px">
        <Typography
          display="inline"
          variant="body2"
          style={{ marginRight: ".5rem" }}
        >
          {t("lastMonthTitle")}
        </Typography>
      </Box>
      <Grid
        container
        spacing={2}
        style={{ marginBottom: "20px" }}
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Grid item xs>
          <ProcessedEmailsCard
            loading={loading}
            previousStats={previousStats.flatMap(s => s.executions)}
            currentStats={currentStats.flatMap(s => s.executions)}
          />
        </Grid>
        <Grid item xs>
          <StorageUploadsCard
            loading={loading}
            previousStats={previousStats.flatMap(s => s.storage)}
            currentStats={currentStats.flatMap(s => s.storage)}
          />
        </Grid>
        <Grid item xs>
          <EmailFlowCard
            loading={loading}
            previousStats={previousStats.flatMap(s => s.flow)}
            currentStats={currentStats.flatMap(s => s.flow)}
          />
        </Grid>
        <Grid item xs>
          <AccountsBlock />
        </Grid>
      </Grid>
    </>
  );
}
